declare global {
  interface Window {
    KakaoAgent: any
    isMobile: any
    BarcodeDetector: any
  }
}

export const isDesktop = () => {
  if (!window.KakaoAgent) return undefined
  return window.KakaoAgent.getAgent().isDesktop
}
